<template>
	<div class="featured-countries is-hidden-touch">
		<div class="buttons has-addons is-centered">
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 16, name: 'Magyarország', languages: {en: 'Hungary'}})">
				{{ $t('Hungary') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8181, name: 'Ausztria', languages: {en: 'Austria'}})">
				{{ $t('Austria') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8310, name: 'Ukrajna', languages: {en: 'Ukraine'}})">
				{{ $t('Ukraine') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8311, name: 'Horvátország', languages: {en: 'Croatia'}})">
				{{ $t('Croatia') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8309, name: 'Szerbia', languages: {en: 'Serbia'}})">
				{{ $t('Serbia') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8168, name: 'Szlovákia', languages: {en: 'Slovakia'}})">
				{{ $t('Slovakia') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8197, name: 'Szlovénia', languages: {en: 'Slovenia'}})">
				{{ $t('Slovenia') }}
			</b-button>
			<b-button type="is-sarga" @click="putToStorage({type: 2, id: 8183, name: 'Románia', languages: {en: 'Romania'}})">
				{{ $t('Romania') }}
			</b-button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		putToStorage(category) {
			if (this.$route.path == '/') this.$router.push({ name: 'Products' })
			this.$root.$emit('refreshFilters', category)
		},
	}
}
</script>

<style lang="scss" scoped>
	.featured-countries {
		margin: 0 -4px 0.75rem -4px;
	}
	.featured-countries .buttons .button {
		width: calc(100% / 8);
	}
</style>
